import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const baseProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export const ArrowRightIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

export const LogInIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3" /></svg>
);

export const AlertIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><path d="M10.3 3.7 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0ZM12 9v4M12 17h.01" /></svg>
);

export const InfoIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
);

export const SuccessIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></svg>
);

export const ErrorIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><circle cx="12" cy="12" r="9" /><path d="m9 9 6 6M15 9l-6 6" /></svg>
);

export const RefreshIcon = (props: IconProps) => (
  <svg {...baseProps} {...props}><path d="M20 12a8 8 0 1 1-2.3-5.7L20 8M20 3v5h-5" /></svg>
);
